<button class="app-button" (click)="handleShowVisualizer(slugArr[0].slug)"
    *ngIf="slugArr.length === 1" [class.full]="full">
    Visualizar anexo
</button>

<div class="button-container" *ngIf="slugArr.length > 1" [class.full]="full">
    <button class="button-container-content" [class.full]="full"
        [class.active]="showOptions" type="button"
        (click)="toggleShowOptions()">
        <div *ngIf="full"></div>

        Visualizar anexos
        <svg-icon src="assets/images/icon-down.svg"></svg-icon>
    </button>
    <div class="dropdown" *ngIf="showOptions">
        <div *ngFor="let item of slugArr; let i = index">
            <button
                (click)="handleShowVisualizer(item.slug)">{{item.label}}</button>
        </div>
    </div>
</div>